module.exports = __webpack_public_path__ + "img/vertical_2_1_8011.4cc7c1dc.png";